$(document).ready(function () {
    setHowManyImagesInARow();
    setStylingForImageOrientation();
});

function setHowManyImagesInARow() {
    var $imageGallery = $('.image-gallery');

    $imageGallery.each(function () {
        var imageGallery = $(this),
            imageGalleryWidth = imageGallery.width(),
            minWidth = 900;

        if (imageGalleryWidth < minWidth) {
            imageGallery.removeClass('many').addClass('few');
        }
    });
}

function setStylingForImageOrientation() {
    var $mediaGalleryImages = $('.image-gallery__image');

    $mediaGalleryImages.each(function () {
        var $image = $(this),
            width = $image.width(),
            height = $image.height();

        if (height > width) {
            $image.addClass('image-gallery__image--portrait');
        } else {
            $image.addClass('image-gallery__image--landscape');
        }
    })
}